export enum StoreModes {
    //1 - продажа, 2 - приход, 3 - списание, редактирование
    sale=1,
    arrival=2,
    writeOff=3,
    get =4
}